import { render, staticRenderFns } from "./DocumentCardSelectDate.vue?vue&type=template&id=254d6b72&lang=pug"
import script from "./DocumentCardSelectDate.vue?vue&type=script&lang=ts"
export * from "./DocumentCardSelectDate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "@/components/DocumentViewCards/views/Card/DocumentCard.i18n.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fhome%2Frunner%2Fwork%2Fcompliance-nationbetter-uk%2Fcompliance-nationbetter-uk%2Fsrc%2Fcomponents%2FDocumentViewCards%2Fviews%2FCard%2Fcomponents%2FDocumentCardSelectDate.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports